<template>
  <div class="run-schedule">
    <page-header title="Калькулятор сроков доставки" />
    <div class="public-container public-container-mobile">
      <div class="run-schedule-block">
        <vz-switcher
          :modelValue="mode"
          :items="modeTypes"
          public-style
          @update:modelValue="onChangeMode"
        />
        <run-schedule-directions
          v-if="isSchedule"
          :date="date"
        />
        <run-schedule-calculation
          v-if="isCalculation"
          :date="date"
          @change-date="onChangeDate"
        />
      </div>
      <div class="run-schedule-note">
        При сдаче груза менее, чем за сутки до отправления рейса - отправка в указанное время не гарантируется.<br>
        Время доставки может увеличиться, так как груз не попадёт в этот рейс.
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { useCityStore } from '@/stores/city'
import { formatDate } from '@/common/date'
import PageHeader from '@/components/public/page-header.vue'
import RunScheduleDirections from '@/components/public/run-schedule/run-schedule-directions.vue'
import RunScheduleCalculation from '@/components/public/run-schedule/run-schedule-calculation.vue'
import {until} from '@vueuse/shared';

const { setFrom, setTo, locationByGuid } = useCityStore()
const { currentCity, rclCityList, from, to } = storeToRefs(useCityStore())
const route = useRoute()

const modeTypes = [
  {
    title: 'Расписание рейсов',
    value: 'schedule'
  },
  {
    title: 'Расчёт сроков доставки',
    value: 'calculation'
  }
]

const mode = ref('schedule')
const date = ref('')

const isCalculation = computed((): Boolean => {
  return mode.value === 'calculation'
})

const isSchedule = computed((): Boolean => {
  return mode.value === 'schedule'
})

await until(() => !!rclCityList.value.length).toBe(true).then(async () => {
  let dispatch = currentCity.value
  let destination = currentCity.value.guid === rclCityList.value[0].guid ? rclCityList.value[1] : rclCityList.value[0]
  let d = route.query.date ? new Date(route.query.date as string) : new Date()

  if (route.query.dispatch) {
    dispatch = await locationByGuid(route.query.dispatch as string)
  }
  if (route.query.destination) {
    destination = await locationByGuid(route.query.destination as string)
  }
  setFrom(dispatch)
  setTo(destination)
  date.value = formatDate(new Date(d), 'YYYY-MM-DD')
})

function onChangeMode (val: string): void {
  mode.value = val
}

function onChangeDate (value: string) {
  date.value = value
}
</script>
